import React from 'react';
import { Button } from 'react-bootstrap';
import { defaultTheme, useTheme, useFlowPortalContent } from '../../context/PortalThemeContext';
import { ClaimStates } from './ClaimStates';
import { PiCheckCircle } from 'react-icons/pi';
import { fallbackString } from '../shared/FallbackUtils';
import './ClaimSubmitted.css';

const ClaimSubmitted = ({ onStepChange, flowType = 'CLAIM' }) => {
    const theme = useTheme();
    const flowPortalContent = useFlowPortalContent(flowType);
    const settings = flowPortalContent?.submitted;
    const defaults = defaultTheme.flowPortalContentSettings.CLAIM.submitted;

    const nextSteps = settings?.nextSteps?.length > 0
        ? settings.nextSteps
        : defaults.nextSteps;

    return (
        <div className="claim-submitted">
            <div className="success-content">
                <div className="success-icon">
                    <PiCheckCircle size={64} color={theme.accentColor || '#28a745'} />
                </div>
                
                <h1 className="success-title">
                    {fallbackString(settings?.title, defaults.title)}
                </h1>
                
                <p className="success-message">
                    {fallbackString(settings?.message, defaults.message)}
                </p>
                
                <div className="next-steps">
                    <h3>{fallbackString(settings?.nextStepsTitle, defaults.nextStepsTitle)}</h3>
                    <ul>
                        {nextSteps.map((step, i) => (
                            <li key={i}>{step}</li>
                        ))}
                    </ul>
                </div>
                
                <div className="action-buttons">
                    <Button 
                        onClick={() => onStepChange(ClaimStates.ORDER_SUMMARY)}
                        className="button-accent"
                        style={{
                            marginTop: '1.5rem',
                            fontSize: '1rem'
                        }}
                    >
                        {fallbackString(settings?.backButtonText, defaults.backButtonText)}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ClaimSubmitted;
